import { signatureKey } from "@/constant/types";
import axios from "axios";

// Create a base axios instance without browser-specific configurations
const createBaseInstance = (baseURL?: string) => {
  const instance = axios.create({
    baseURL: baseURL || process.env.NEXT_PUBLIC_APP_API || "",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    }
  });
  
  return instance;
};

// Only configure browser-specific features if we're in a browser environment
if (typeof window !== 'undefined') {
  // Default axios settings
  axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";
  axios.defaults.baseURL = process.env.NEXT_PUBLIC_APP_API || "";
  
  // Add auth token for browser requests
  axios.interceptors.request.use(function (config) {
    const saveData = JSON.parse(window.localStorage.getItem(signatureKey) || "{}");
    if (saveData?.accessToken && config.headers && config.url) {
      config.headers["Authorization"] = `Bearer ${saveData.accessToken}`;
    }
    return config;
  });
  
  // Handle auth errors
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    async function (error) {
      if (error.response?.status === 401) {
        window.localStorage.setItem(signatureKey, "");
      } else {
        return Promise.reject(error);
      }
    },
  );
}

// Create instances
const defaultInstance = createBaseInstance(process.env.NEXT_PUBLIC_APP_API);
const cloudfrontAxios = createBaseInstance(process.env.NEXT_PUBLIC_CLOUDFRONT_API);

// Only configure browser-specific features if we're in a browser environment
if (typeof window !== 'undefined') {
  // Add request interceptor for the default instance
  defaultInstance.interceptors.request.use(function (config) {
    const saveData = JSON.parse(window.localStorage.getItem(signatureKey) || "{}");
    const appApiBaseUrl = process.env.NEXT_PUBLIC_CLOUDFRONT_URL;
    
    if (saveData?.accessToken && config.headers && config.url && !config.url.includes(appApiBaseUrl ?? "")) {
      config.headers["Authorization"] = `Bearer ${saveData.accessToken}`;
    }
    return config;
  });
  
  // Handle auth errors for default instance
  defaultInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    async function (error) {
      if (error?.response?.status === 401) {
        window.localStorage.setItem(signatureKey, "");
      } else {
        return Promise.reject(error);
      }
    },
  );
}

export { defaultInstance as axiosClient, cloudfrontAxios };